<template>
  <v-container fluid grid-list-sm>
        <v-card>
          <!-- <v-toolbar dark color="primary">
            <v-toolbar-title>Choose transaction type</v-toolbar-title>
            <v-spacer/>
            <v-toolbar-items>
              <v-btn icon dark >
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar> -->
          <v-tabs
            centered
            color="primary"
            dark
            icons-and-text
            fixed-tabs
            scrollable
            slider-color
          >
            <v-tabs-slider color="yellow"></v-tabs-slider> 

            <v-tab :key="2" @click="transfer = false; deposit=false; expense=true; withdrawl=false; income=false; asset=false; staff=false; liability=false;">
              Expense
              <v-icon>money_off</v-icon>
            </v-tab>

            <v-tab :key="3" @click="transfer = false; deposit=false; expense=false; withdrawl=false; income=true; asset=false; staff=false; liability=false;">
              Income
              <v-icon>money_off</v-icon>
            </v-tab>

            <v-tab :key="4" @click="transfer = false; deposit=false; expense=false; withdrawl=false; income=false; asset=true; staff=false; liability=false;">
              Asset
              <v-icon>money_off</v-icon>
            </v-tab>

            <v-tab :key="5" @click="transfer = false; deposit=false; expense=false; withdrawl=false; income=false; asset=false; staff=true; liability=false;">
              Salary
              <v-icon>money_off</v-icon>
            </v-tab>

            <v-tab :key="6" @click="transfer = false; deposit=false; expense=false; withdrawl=false; income=false; asset=false; staff=false; liability=true;">
              Common
              <v-icon>money_off</v-icon>
            </v-tab>

          <!-- Expense Tab-->   
          <v-tab-item :key="2">
            <expense-tab
              v-if="expense"
              :selectedBrand="selectedBrand || []" 
              :firmsByBrand="firmsByBrand || []"
              :accountsByBrand="accountsByBrand || []"
              @notify="notify"
              @closeDialog="closeDialog"
            />
          </v-tab-item>
          
          <!-- Income Tab -->
          <v-tab-item :key="3">
            <income-tab
                v-if="income"
                :selectedBrand="selectedBrand || []" 
                :firmsByBrand="firmsByBrand || []"
                :accountsByBrand="accountsByBrand || []"
                @notify="notify"
                @closeDialog="closeDialog"
              />
          </v-tab-item>
          
          <!-- Asset Tab -->
          <v-tab-item :key="4">
              <asset-tab
                v-if="asset"
                :selectedBrand="selectedBrand || []" 
                :firmsByBrand="firmsByBrand || []"
                :accountsByBrand="accountsByBrand || []"
                :assetByBrand="assetByBrand || []"
                @notify="notify"
                @closeDialog="closeDialog"
              />
          </v-tab-item>
          
          <!-- Staff Tab-->
          <v-tab-item :key="5">          
                <salary-tab
                  v-if="staff"
                  :selectedBrand="selectedBrand || []" 
                  :firmsByBrand="firmsByBrand || []"
                  :accountsByBrand="accountsByBrand || []"
                  :assetByBrand="assetByBrand || []"
                  :staffAccount="getStaff || []"
                  @notify="notify"
                  @closeDialog="closeDialog"
                />
              <!-- End of Staff Account -->
          </v-tab-item>
          <!-- Expense Tab-->   
          <v-tab-item :key="6">
            <liability-tab
              v-if="liability"
              :selectedBrand="selectedBrand || []" 
              :firmsByBrand="firmsByBrand || []"
              :accountsByBrand="accountsByBrand || []"
              :assetByBrand="assetByBrand || []"
              :staffAccount="getStaff || []"
              @notify="notify"
              @closeDialog="closeDialog"
            />
          </v-tab-item>
        </v-tabs>
      </v-card>
  

    <v-snackbar
      v-model="snackbar"
      top
      color="error"
      :timeout="3000"
    >
   {{snackbarText}}
    </v-snackbar>
    <v-snackbar
      v-model="snackbarSuccess"
      top
      color="success"
      :timeout="3000"
    >
   {{snackbarSuccessText}}
    </v-snackbar>

  </v-container>
  
</template>

<script>

import {
    ASSET_TYPE_WITH_DEPRICIATION,
    ASSET_CATEGORY,
    ASSET_PURCHASE_TYPE,
    PAYMENT_OPTIONS,
    getFinancialYear
} from './tabs/utils';


import { createNamespacedHelpers } from 'vuex'

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters'];
import { debug } from 'util';
import { setTimeout } from 'timers';

import ExpenseTab from './tabs/expense';
import IncomeTab from './tabs/income';
import AssetTab from './tabs/asset';
import SalaryTab from './tabs/salary';
import LiabilityTab from './tabs/liability';

export default {
  components: {
      ExpenseTab,
      IncomeTab,
      AssetTab,
      SalaryTab,
      LiabilityTab
  },
  data: () => ({
    tabs: [
      'transfer', 'deposit', 'withdrawl', 'expense', 'income', 'asset', 'salary', 'liability'
    ],
    transferType : 'Transfer',
    transferCategory : 'B2B',
    bankTransferData :  {
      firm : null,
      dipositeVia : null,
      remark : null
    },
    bankTransferType : null,
    color: null,
    timeout:3000,
    transferdatepicker: false,
    depositdatepicker: false,
    withdrawldatepicker: false,
    incomedatepicker: false,
    staffdatepicker: false,
    transferInvoiceDate: null,
    depostInvoiceDate: null,
    withdrawlInvoiceDate: null,
    incomeInvoiceDate: null,
    staffInvoiceDate: null,
    depositVia: 'cash',
    withdrawlVia: 'cash',
    expenseVia: 'cash',
    incomeVia: 'cash',
    assetVia: 'cash',
    staffVia: 'cash',
    transferTotalAmount:null,
    depositTotalAmount:null,
    withdrawlTotalAmount:null,
    expenseAmount:null,
    incomeAmount:null,
    staffAmount:null,
    assetAmount:null,
    snackbarSuccessText:null,
    snackbarText:null,
    snackbar : false,
    snackbarSuccess:false,
    transfer:false,
    deposit:false,
    withdrawl:false,
    expense:true,
    income:false,
    asset: false,
    staff: false,
    liability: false,
    depositType:null,
    date: null,
    firms: [],
    accounts:[],
    expenses:[],
    liabilities: [],
    incomes:[],
    assets:[],
    staffs:[],
    liabilities: [],
    selectExpense:null,
    selectIncome:null,
    selectAsset:null,
    selectStaff:null,
    selectedFirm:null,
    selectedAccountFromAccount:null,
    selectedAccountToAccount:null,
    selectAccountToDeposit:null,
    selectedFirmToDeposit:null,
    selectAccountToWithdrawl:null,
    selectedFirmToWithdrawl:null,
    searchInput: null,
    searchInputFromAccount: null,
    searchInputToAccount: null,
    selectedFirmFromExpense:null,
    selectAccountFromExpense:null,  
    selectedFirmFromIncome:null,
    selectAccountFromIncome:null,
    selectedFirmFromStaff:null,
    selectAccountFromStaff:null,     
    expenseRemark:null,
    withdrawlRemark: null,
    depositRemark: null,
    incomeRemark:null,
    assetRemark:null,
    staffRemark: null,
    debitStatus: ['Due', 'Paid', 'Partial Paid'],
    dialog12: false,
    salaryInvoiceDate: null,
    salaryTransactionType: null,
    salaryOperationAccountForTransaction: null,
    salaryOperationAmountFromCash: null,
    salaryOperationAmountFromBank: null,
  }),
  created () {
    this.$bindAsArray(
        'firms',
        this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
        'accounts',
        this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
        'expenses',
        this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
        'liabilities',
        this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
        'incomes',
        this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
        'staffs',
        this.$root.$firebaseRefs.staffs.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
        'assets',
        this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
        'staffaccount',
        this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand)
    )
    let today = new Date()
    this.date = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    this.salaryInvoiceDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}` 
    this.transferInvoiceDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    if(this.$route.params.type) {
      switch(this.$route.params.type) {
        case 'expenses' : {
          this.transfer = false; 
          this.deposit=false; 
          this.expense=true; 
          this.withdrawl=false; 
          this.income=false; 
          this.asset=false; 
          this.staff=false; 
          this.liability=false;
          break;
        }
      }
    }
  },
  computed: {
    ...mapGlobalGetters(['selectedBrand','brandFinYear']),
     accountsByFirm() {
          if(this.selectedFirmFromAsset) {
              return this.accountsByBrand.filter(item => item.account.firm === this.selectedFirmFromAsset)
          }
          return []
      },
      otherAccountByBrand() {
          return this.accountsByFirm.filter(account => account.account.accountType !== 'Loan A/C')
      },
      loanAccountByBrand() {
          return this.accountsByFirm.filter(account => account.account.accountType === 'Loan A/C')
      }, 
     paymentOptions() { 
        console.log(PAYMENT_OPTIONS);
        return PAYMENT_OPTIONS 
      },
     getTransactionTypeOptions() {
        return [
          { text: 'Salary', value: 'salary'},
          {text: 'Advance', value: 'advance'},
          {text: 'Commission', value: 'commission'},
          {text: 'Return', value: 'Return'}
        ] 
      },
    firmsByBrand () {
        return this.firms.filter((item) => 
            item['brand'] === this.selectedBrand
        ).map(item => {
          return {
            firm: item,
            text: item['name'],
            value: item['.key'],
            defaultFirm: item['defaultFirm']
          }
        })
    },
    accountsByBrand () {
        return this.accounts.filter((item) => 
            item['brand'] === this.selectedBrand
        ).map(item => {
          return {
            account: item,
            text: item['accountnumber'],
            value: item['.key']
          }
        })
    },
    accountsByFirm () {
        return this.accounts.filter((item) => 
            item['brand'] === this.selectedBrand && 
            item['firm'] === this.bankTransferData.firm
        ).map(item => {
          return {
            account: item,
            text: item['accountnumber'],
            value: item['.key']
          }
        })
    },
    expenseByBrand() {
      return this.expenses.filter((item) =>
        item['brand'] === this.selectedBrand
      ).map(item =>{
        return{
          text : item['expense'],
          value: item['.key']
        }
      })
    },
    liabilityByBrand() {
      return this.liabilities.filter((item) =>
        item['brand'] === this.selectedBrand
      ).map(item =>{
        return{
          text : item['liability'],
          value: item['.key']
        }
      })
    },
    incomeByBrand() {
      return this.incomes.filter((item) =>
        item['brand'] === this.selectedBrand
      ).map(item =>{
        return{
          text : item['income'],
          value: item['.key']
        }
      })
    },
    assetByBrand() {
      return this.assets.filter((item) =>
        item['brand'] === this.selectedBrand
      ).map(item =>{
        return{
          asset: item,
          text : item['asset'],
          value: item['.key']
        }
      })
    },
    staffByBrand() {
      return this.staffs.filter((item) =>
        item['brand'] === this.selectedBrand
      ).map(item =>{
        return{

          text : item['staff'],
          value: item['.key']
        }
      })
    },
    getStaff() {
      return this.staffaccount.filter((item) =>
        item['brand'] === this.selectedBrand
      ).map(item =>{
        return{
          staff: item,
          text : item['staffName'],
          value: item['.key']
        }
      })
    },
  },
  methods:{
    notify(message, isSuccess) {
      if(isSuccess) {
        this.snackbarSuccess = true;
        this.snackbarSuccessText = message
      } else {
        this.snackbar = true;
        this.snackbarText = message;
      }
    },
    closeDialog() {
      
    },
    firmNameById (id) {
        return this.firms.filter(item=> item['.key'] == id)[0].name
    },
    addInvoice(accountFromFirm, accountToFirm, fromAccount, toAccount, transferTotalAmount, transactionType,fromAccountKey,toAccountKey){
      let invoiceDataCredit = {
          brand: this.selectedBrand,
          brandFinYear : this.brandFinYear,
          type:'automatic invoice',
          transactionType,
          firm:accountToFirm,
          paymentType:'bank',
          accountNumber:toAccount,
          isCredited:true,
          totalAmount:Number(transferTotalAmount),
          date: this.transferInvoiceDate ? Date.parse(this.transferInvoiceDate) : Date.now(),
          transferCategory : this.transferCategory
      }
      let invoiceDataDebit = {
          brand: this.selectedBrand,
          brandFinYear : this.brandFinYear,
          type:'automatic invoice',
          transactionType,
          firm:accountFromFirm,
          paymentType:'bank',
          accountNumber:fromAccount,
          isCredited:false,
          totalAmount:Number(transferTotalAmount),
          date: this.transferInvoiceDate ? Date.parse(this.transferInvoiceDate) : Date.now(),
          transferCategory : this.transferCategory
      }

      if (this.transferCategory == 'B2B') {
        invoiceDataCredit['transferType'] = this.bankTransferType;
        invoiceDataCredit['bank'] = toAccountKey;
        invoiceDataDebit['transferType'] = this.bankTransferType;
        invoiceDataDebit['bank'] = fromAccountKey;
        invoiceDataCredit['remark'] = this.bankTransferData.remark;
        invoiceDataDebit['remark'] = this.bankTransferData.remark;
      
      } else if (this.transferCategory == "B2C") {
        invoiceDataCredit['depositVia'] = this.bankTransferData.depositVia;
        invoiceDataCredit['remark'] = this.bankTransferData.remark;
        invoiceDataDebit['bank'] = fromAccountKey

        invoiceDataDebit['depositVia'] = this.bankTransferData.depositVia;
        invoiceDataDebit['remark'] = this.bankTransferData.remark;

      } else if(this.transferCategory == "C2B") {
        invoiceDataCredit['depositVia'] = this.bankTransferData.depositVia;
        invoiceDataCredit['remark'] = this.bankTransferData.remark;
        invoiceDataCredit['bank'] = toAccountKey;

        invoiceDataDebit['depositVia'] = this.bankTransferData.depositVia;
        invoiceDataDebit['remark'] = this.bankTransferData.remark;
       }
      this.$root.$firebaseRefs.invoice.push(invoiceDataCredit);
      this.$root.$firebaseRefs.invoice.push(invoiceDataDebit);
      this.closeDialog();
    },

    // Deposit Invoice 

    addInvoiceDeposit(depositVia,selectedFirmToDeposit,depositTotalAmount,depositRemark,fromAccount){
      let invoiceViaCash = {
          brand: this.selectedBrand,
          brandFinYear : this.brandFinYear,
          type:'automatic invoice',
          transactionType: 'Deposit',
          firm:selectedFirmToDeposit,
          paymentType:depositVia,
          accountNumber:'',
          depositVia : this.bankTransferData.depositVia,
          isCredited:true,
          totalAmount:Number(depositTotalAmount),
          remark:depositRemark,
          date: this.depositInvoiceDate ? Date.parse(this.depositInvoiceDate) : Date.now()
      }
      let invoiceViaAccount = {
          brand: this.selectedBrand,
          brandFinYear : this.brandFinYear,
          type:'automatic invoice',
          transactionType: 'Deposit',
          firm:selectedFirmToDeposit,
          paymentType:depositVia,
          depositVia : this.bankTransferData.depositVia,
          accountNumber:fromAccount,
          isCredited:true,
          totalAmount:Number(depositTotalAmount),
          remark:depositRemark,
          date: this.depositInvoiceDate ? Date.parse(this.depositInvoiceDate) : Date.now()
      }
      if(depositVia == 'cash'){
        this.$root.$firebaseRefs.invoice.push(invoiceViaCash);
      }else{
        this.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
      }
    },

    // Withdrawl Invoice 

      addInvoiceWithdrawl(withdrawlVia,selectedFirmToWithdrawl,withdrawlTotalAmount,withdrawlRemark,fromAccount){
      let invoiceViaCash = {
          brand: this.selectedBrand,
          brandFinYear : this.brandFinYear,
          type:'automatic invoice',
          transactionType: 'With Drawl',
          firm:selectedFirmToWithdrawl,
          paymentType:withdrawlVia,
          accountNumber:'',
          isCredited:false,
          totalAmount:Number(withdrawlTotalAmount),
          remark:withdrawlRemark,
          date: this.withdrawlInvoiceDate ? Date.parse(this.withdrawlInvoiceDate) : Date.now()
      }
      let invoiceViaAccount = {
          brand: this.selectedBrand,
          brandFinYear : this.brandFinYear,
          type:'automatic invoice',
          transactionType: 'With Drawl',
          firm:selectedFirmToWithdrawl,
          paymentType:withdrawlVia,
          accountNumber:fromAccount,
          isCredited:false,
          totalAmount:Number(withdrawlTotalAmount),
          remark:withdrawlRemark,
          date: this.withdrawlInvoiceDate ? Date.parse(this.withdrawlInvoiceDate) : Date.now()
      }
      if(withdrawlVia == 'cash'){
        this.$root.$firebaseRefs.invoice.push(invoiceViaCash);
      }else{
        this.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
      }
    },

    // Income Invoice 
    addInvoiceIncome(incomeVia,incomeType,firmOfIncome,incomeAmount,incomeRemark,accountOfIncome){
      let invoiceViaCash = {
          brand: this.selectedBrand,
          brandFinYear : this.brandFinYear,
          type:'automatic invoice',
          transactionType: 'Income',
          firm:firmOfIncome,
          paymentType:incomeVia,
          accountNumber:'',
          isCredited:true,
          totalAmount:Number(incomeAmount),
          remark:incomeRemark,
          incomeType:incomeType,
          date:this.incomeInvoiceDate ? Date.parse(this.incomeInvoiceDate) : Date.now()
      }
      let invoiceViaAccount = {
          brand: this.selectedBrand,
          brandFinYear : this.brandFinYear,
          type:'automatic invoice',
          transactionType: 'Income',
          firm:firmOfIncome,
          paymentType:incomeVia,
          accountNumber:accountOfIncome,
          isCredited:true,
          totalAmount:Number(incomeAmount),
          remark:incomeRemark,
          incomeType:incomeType,
          date:this.incomeInvoiceDate ? Date.parse(this.incomeInvoiceDate) : Date.now()
      }
      if(incomeVia == 'cash'){
        this.$root.$firebaseRefs.invoice.push(invoiceViaCash);
      }else{
        this.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
      }
    },

    // Staff Invoice 
    addInvoiceStaff(staffVia,staffType,firmOfStaff,staffAmount,staffRemark,accountOfStaff){
      let invoiceViaCash = {
          brand: this.selectedBrand,
          brandFinYear : this.brandFinYear,
          type:'automatic invoice',
          transactionType: 'Staff',
          firm:firmOfStaff,
          paymentType:staffVia,
          accountNumber:'',
          isCredited:false,
          totalAmount:Number(staffAmount),
          remark:staffRemark,
          staffType:staffType,
          date: this.staffInvoiceDate ? Date.parse(this.staffInvoiceDate) : Date.now()
      }
      let invoiceViaAccount = {
          brand: this.selectedBrand,
          brandFinYear : this.brandFinYear,
          type:'automatic invoice',
          transactionType: 'Staff',
          firm:firmOfStaff,
          paymentType:staffVia,
          accountNumber:accountOfStaff,
          isCredited:false,
          totalAmount:Number(staffAmount),
          remark:staffRemark,
          staffType:staffType,
          date: this.staffInvoiceDate ? Date.parse(this.staffInvoiceDate) : Date.now()
      }
      if(staffVia == 'cash'){
        this.$root.$firebaseRefs.invoice.push(invoiceViaCash);
      }else{
        this.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
      }
    },

    // Transfer Functionality

    transferAmount(){
      switch (this.transferCategory) {
        case 'B2B' : {
          this.bankToBank();
          break;
        }
        case 'C2B' : {
          this.cashToBank();
          break;
        }
        case 'B2C' : {
          this.bankToCash();
          break;
        }
      }
    },

    bankToBank(){
      var self = this;
      let result = this.checkForSameAccount();
      let accountFromFirm= null, fromAccount=null, accountToFirm=null, toAccount=null;
      if(result){
        if(this.transferTotalAmount == null){
          this.snackbar = true;
          this.snackbarText='Amount cannot be empty';
        }else{
          this.$root.$firebaseRefs.account.child(this.selectedAccountFromAccount).once('value').then( function(snap) {
             accountFromFirm = snap.val().firm;
             fromAccount = snap.val().accountnumber;
            if(Number(snap.val().amount) >= Number(self.transferTotalAmount)){
                let amount = Number(self.transferTotalAmount)
                self.$root.$firebaseRefs.account.child(self.selectedAccountFromAccount).update({
                 amount: Number(snap.val().amount) - Number(self.transferTotalAmount)
                });
                self.$root.$firebaseRefs.account.child(self.selectedAccountToAccount).once('value').then( function(snap) {
                   accountToFirm = snap.val().firm;
                   toAccount = snap.val().accountnumber;
                  self.$root.$firebaseRefs.account.child(self.selectedAccountToAccount).update({
                      amount: Number(snap.val().amount) + Number(self.transferTotalAmount)
                  });
                });
                setTimeout(function(){
                  self.addInvoice(self.bankTransferData.firm,self.bankTransferData.firm,fromAccount,toAccount,self.transferTotalAmount, 'Transfer' ,self.selectedAccountFromAccount,self.selectedAccountToAccount); 
                  self.reduceFromToAccount(); 
                },1000)              
            }else{
              self.snackbar = true;
              self.snackbarText='Insufficient Balance'
            }
          })
        }
      }else{
        this.snackbar=true;
        this.snackbarText='Both Accounts cannot be same'
      }
    },

    bankToCash(){
      var self = this;
      let fromAccount=null
        if(this.transferTotalAmount == null){
          this.snackbar = true;
          this.snackbarText='Amount cannot be empty';
        }else{
          this.$root.$firebaseRefs.account.child(this.selectedAccountFromAccount).once('value').then( function(snap) {
             fromAccount = snap.val().accountnumber;
            if(Number(snap.val().amount) >= Number(self.transferTotalAmount)){
                let amount = Number(self.transferTotalAmount)
                self.$root.$firebaseRefs.account.child(self.selectedAccountFromAccount).update({
                 amount: Number(snap.val().amount) - Number(self.transferTotalAmount)
                });

                self.$root.$firebaseRefs.firm.child(self.bankTransferData.firm).once('value').then( function(snap) {
                self.$root.$firebaseRefs.firm.child(self.bankTransferData.firm).update({
                  amount: Number(snap.val().amount) + Number(self.transferTotalAmount)
                });
              })
              setTimeout(function(){
                  self.addInvoice(self.bankTransferData.firm,self.bankTransferData.firm,fromAccount,'',self.transferTotalAmount, 'Transfer',self.selectedAccountFromAccount,null); 
                  self.reduceFromToAccount(); 
              },1000)              
            }else{
              self.snackbar = true;
              self.snackbarText='Insufficient Balance'
            }
          })
        }
    },
    cashToBank(){
      var self = this;
      let toAccount=null
        if(this.transferTotalAmount == null){
          this.snackbar = true;
          this.snackbarText='Amount cannot be empty';
        }else{
          this.$root.$firebaseRefs.firm.child(this.bankTransferData.firm).once('value').then( function(snap) {
             
            if(Number(snap.val().amount) >= Number(self.transferTotalAmount)){
                let amount = Number(self.transferTotalAmount)
                self.$root.$firebaseRefs.firm.child(self.bankTransferData.firm).update({
                 amount: Number(snap.val().amount) - Number(self.transferTotalAmount)
                });

                self.$root.$firebaseRefs.account.child(self.selectedAccountToAccount).once('value').then( function(snap) {
                toAccount = snap.val().accountnumber;
                self.$root.$firebaseRefs.account.child(self.selectedAccountToAccount).update({
                  amount: Number(snap.val().amount) + Number(self.transferTotalAmount)
                });
              })
              setTimeout(function(){
                self.addInvoice(self.bankTransferData.firm,self.bankTransferData.firm,'',toAccount,self.transferTotalAmount, 'Transfer',null,self.selectedAccountToAccount); 
                self.reduceFromToAccount(); 
              },1000)              
            }else{
              self.snackbar = true;
              self.snackbarText='Insufficient Balance'
            }
          })
        }

    },
    reduceFromToAccount(){
      var self = this;
      self.snackbarSuccess = true;
      self.snackbarSuccessText ='Amount Transfered';
      self.transferTotalAmount = null;
      self.selectedAccountFromAccount = null;
      self.selectedAccountToAccount = null;
      self.bankTransferData.firm = null;
      self.bankTransferData.dipositeVia = null;
      self.bankTransferData.remark = null;
      self.bankTransferType = null;
    },
    checkForSameAccount() {
      if(this.selectedAccountToAccount != null && this.selectedAccountFromAccount != null){
        if(this.selectedAccountFromAccount == this.selectedAccountToAccount){
          this.snackbar=true;
          this.snackbarText='Both Accounts cannot be same'
          return false;
        }else{
          return true;
        }
      }
    },

    // Deposit Functionality

    depositAmount(){
      var self = this;
      if(this.depositRemark != null){
        if(this.depositTotalAmount != null){
        if(this.depositVia == 'cash'){
          if(this.selectedFirmToDeposit != null){
           this.$root.$firebaseRefs.firm.child(this.selectedFirmToDeposit).once('value').then( function(snap) {
            self.$root.$firebaseRefs.firm.child(self.selectedFirmToDeposit).update({
              amount: Number(snap.val().amount) + Number(self.depositTotalAmount)
              });
          })
          self.snackbarSuccess=true;
          self.snackbarSuccessText = "Amount Deposited";
          setTimeout(function(){
            self.addInvoiceDeposit(self.depositVia,self.selectedFirmToDeposit,self.depositTotalAmount,self.depositRemark)
            self.depositTotalAmount = null;
            self.depositRemark = null;
            self.selectedFirmToDeposit = null;
          },1000)  
        }else{
          this.snackbar = true;
          this.snackbarText = 'Please select firm to deposit'
        }
      }else{
        let depositAccountFirm = null;
        let depositAccountNumber = null;
        if(this.selectAccountToDeposit !=null){
          if(this.depositTotalAmount !=null){
            this.$root.$firebaseRefs.account.child(this.selectAccountToDeposit).once('value').then( function(snap) {
              depositAccountFirm = snap.val().firm;
              depositAccountNumber = snap.val().accountnumber;
              self.$root.$firebaseRefs.account.child(self.selectAccountToDeposit).update({
                amount: Number(snap.val().amount) + Number(self.depositTotalAmount)
                });
              self.snackbarSuccess=true;
              self.snackbarSuccessText = "Amount Deposited";
              setTimeout(function(){
                self.addInvoiceDeposit(self.depositVia,depositAccountFirm, self.depositTotalAmount, self.depositRemark, depositAccountNumber)
                self.depositTotalAmount = null;
                self.depositRemark = null;
                self.selectAccountToDeposit = null;
              })
            })
          }else{
            this.snackbar = true;
            this.snackbarText = 'Please enter an amount'
          }
        }else{
          this.snackbar = true;
          this.snackbarText = 'Please select account to deposit'
        }
      }
      }
      } 
    },

    // Withdrawl Functionality

    withdrawlAmount(){
      var self=this;
      if(this.withdrawlRemark != null){
        if(this.withdrawlTotalAmount != null){
            if(this.withdrawlVia == 'cash'){
              this.$root.$firebaseRefs.firm.child(this.selectedFirmToWithdrawl).once('value').then( function(snap) {
                if(Number(snap.val().amount) >= self.withdrawlTotalAmount){
                  self.$root.$firebaseRefs.firm.child(self.selectedFirmToWithdrawl).update({
                  amount: Number(snap.val().amount) - Number(self.withdrawlTotalAmount)
                  });
                  self.snackbarSuccess=true;
                  self.snackbarSuccessText = "amount Withdrawn";
                  setTimeout(function(){
                    self.addInvoiceWithdrawl(self.withdrawlVia,self.selectedFirmToWithdrawl, self.withdrawlTotalAmount, self.withdrawlRemark)
                    self.withdrawlTotalAmount = null;
                    self.withdrawlRemark = null;
                    self.selectedFirmToWithdrawl = null;
                  }, 1000)
                }else{
                  self.snackbar = true;
                  self.snackbarText = 'Insufficient Balance to Withdraw'
                }
              })
            }else{
              let withdrawlAccountNumber = null;
              let withdrawlAccountFirm= null;
              this.$root.$firebaseRefs.account.child(this.selectAccountToWithdrawl).once('value').then( function(snap) {
                withdrawlAccountFirm = snap.val().firm;
                withdrawlAccountNumber = snap.val().accountnumber;
                if(Number(snap.val().amount) >= self.withdrawlTotalAmount){
                  self.$root.$firebaseRefs.account.child(self.selectAccountToWithdrawl).update({
                  amount: Number(snap.val().amount) - Number(self.withdrawlTotalAmount)
                  });
                  self.snackbarSuccess=true;
                  self.snackbarSuccessText = "amount withdrawn";
                  setTimeout(function(){
                    self.addInvoiceWithdrawl(self.withdrawlVia, withdrawlAccountFirm, self.withdrawlTotalAmount, self.withdrawlRemark,withdrawlAccountNumber)
                    self.withdrawlTotalAmount = null;
                    self.withdrawlRemark = null;
                    self.selectAccountToWithdrawl = null;
                  })
                }else{
                  self.snackbar = true;
                  self.snackbarText = 'Insufficient Balance to Withdraw'
                }
              })
            }
          }
        } 
      },
    
    
    // Expense Functionality

    expenseAmountClick:function(e){
      var self=this;
      if(this.expenseRemark !=null){
        if(this.expenseAmount != null){
          if(this.selectExpense != null){
            if(this.expenseVia == 'cash'){
              this.$root.$firebaseRefs.firm.child(this.selectedFirmFromExpense).once('value').then( function(snap) {
                if(Number(snap.val().amount) >= self.expenseAmount){
                  self.$root.$firebaseRefs.firm.child(self.selectedFirmFromExpense).update({
                  amount: Number(snap.val().amount) - Number(self.expenseAmount)
                  });
                  self.snackbarSuccess=true;
                  self.snackbarSuccessText = "expense amount paid";
                  setTimeout(function(){
                    self.addInvoiceExpense(self.expenseVia,self.selectExpense,self.selectedFirmFromExpense, self.expenseAmount,self.expenseRemark)
                    self.expenseAmount = null;
                    self.selectedFirmFromExpense = null;
                    self.expenseRemark = null;
                    self.selectExpense = null;
                  })
                }else{
                  self.snackbar = true;
                  self.snackbarText = 'Insufficient Balance'
                }
              })
            }else{
              let expenseAccountFirm= null;
              let expenseAccountNumber =null;
              this.$root.$firebaseRefs.account.child(this.selectAccountFromExpense).once('value').then( function(snap) {
                expenseAccountFirm = snap.val().firm;
                expenseAccountNumber = snap.val().accountnumber;
                if(Number(snap.val().amount) >= self.expenseAmount){
                  self.$root.$firebaseRefs.account.child(self.selectAccountFromExpense).update({
                  amount: Number(snap.val().amount) - Number(self.expenseAmount)
                  });
                  self.snackbarSuccess=true;
                  self.snackbarSuccessText = "expense amount paid";
                  setTimeout(function(){
                    self.addInvoiceExpense(self.expenseVia,self.selectExpense,expenseAccountFirm, self.expenseAmount,self.expenseRemark,expenseAccountNumber)
                    self.expenseAmount = null;
                    self.selectAccountFromExpense = null;
                    self.expenseRemark = null;
                    self.selectExpense = null;
                  })
                }else{
                  self.snackbar = true;
                  self.snackbarText = 'Insufficient Balance'
                }
              })
            }
          }else{
            this.snackbar = true;
            this.snackbarText = 'Please enter a expense type'
          }
        }else{
          this.snackbar = true;
          this.snackbarText = 'Please enter an amount'
        }
      }else{
        this.snackbar = true;
        this.snackbarText = 'Please enter a remark'
      }
    },
    addExpense:function(e){
      let expenseData = {
          brand: this.selectedBrand,
          expense: e.target.value
      }
      this.$root.$firebaseRefs.expenses.push(expenseData);
    },

    // Staff Functionality

    staffAmountClick:function(e){
      var self=this;
      if(this.staffRemark !=null){
        if(this.staffAmount != null){
          if(this.selectStaff != null){
            if(this.staffVia == 'cash'){
              this.$root.$firebaseRefs.firm.child(this.selectedFirmFromStaff).once('value').then( function(snap) {
                if(Number(snap.val().amount) >= self.staffAmount){
                  self.$root.$firebaseRefs.firm.child(self.selectedFirmFromStaff).update({
                      amount: Number(snap.val().amount) - Number(self.staffAmount)
                  });
                  self.snackbarSuccess=true;
                  self.snackbarSuccessText = "staff amount paid";
                  setTimeout(function(){
                    self.addInvoiceStaff(self.staffVia,self.selectStaff,self.selectedFirmFromStaff, self.staffAmount,self.staffRemark)
                    self.staffAmount = null;
                    self.selectedFirmFromStaff = null;
                    self.staffRemark = null;
                    self.selectStaff = null;
                  })
                }else{
                  self.snackbar = true;
                  self.snackbarText = 'Insufficient Balance To Pay'
                }
              })
            }else{
              let staffAccountFirm= null;
              let staffAccountNumber =null;
              this.$root.$firebaseRefs.account.child(this.selectAccountFromStaff).once('value').then( function(snap) {
                staffAccountFirm = snap.val().firm;
                staffAccountNumber = snap.val().accountnumber;
                if(Number(snap.val().amount) >= self.staffAmount){
                  self.$root.$firebaseRefs.account.child(self.selectAccountFromStaff).update({
                  amount: Number(snap.val().amount) - Number(self.staffAmount)
                  });
                  self.snackbarSuccess=true;
                  self.snackbarSuccessText = "staff amount paid";
                  setTimeout(function(){
                    self.addInvoiceStaff(self.staffVia,self.selectStaff,staffAccountFirm, self.staffAmount,self.staffRemark,staffAccountNumber)
                    self.staffAmount = null;
                    self.selectAccountFromStaff = null;
                    self.staffRemark = null;
                    self.selectStaff = null;
                  })
                }else{
                  self.snackbar = true;
                  self.snackbarText = 'Insufficient Balance To Pay'
                }
              })
            }
          }else{
            this.snackbar = true;
            this.snackbarText = 'Please enter a staff Name'
          }
        }else{
          this.snackbar = true;
          this.snackbarText = 'Please enter an amount'
        }
      }else{
        this.snackbar = true;
        this.snackbarText = 'Please enter a remark'
      }
    },
    addStaff:function(e){
      let staffData = {
          brand: this.selectedBrand,
          staff: e.target.value
      }
      this.$root.$firebaseRefs.staffs.push(staffData);
    },
    
    // Income Functionality
    incomeAmountClick:function(e){
      var self=this;
      if(this.incomeRemark !=null){
        if(this.incomeAmount != null){
          if(this.selectIncome != null){
            if(this.incomeVia == 'cash'){
              this.$root.$firebaseRefs.firm.child(this.selectedFirmFromIncome).once('value').then( function(snap) {
                // if(Number(snap.val().amount) >= self.incomeAmount) 
                  {
                  self.$root.$firebaseRefs.firm.child(self.selectedFirmFromIncome).update({
                  amount: Number(snap.val().amount) + Number(self.incomeAmount)
                  })
                  self.snackbarSuccess=true;
                  self.snackbarSuccessText = "Income Received";
                  setTimeout(function(){
                    self.addInvoiceIncome(self.incomeVia,self.selectIncome,self.selectedFirmFromIncome, self.incomeAmount,self.incomeRemark)
                    self.incomeAmount = null;
                    self.selectedFirmFromIncome = null;
                    self.incomeRemark = null;
                    self.selectIncome = null;
                  })
                }
              })
            }else{  
              let incomeAccountFirm= null;
              let incomeAccountNumber =null;
              this.$root.$firebaseRefs.account.child(this.selectAccountFromIncome).once('value').then( function(snap) {
                incomeAccountFirm = snap.val().firm;
                incomeAccountNumber = snap.val().accountnumber;
                // if(Number(snap.val().amount) >= self.incomeAmount)
                {
                  self.$root.$firebaseRefs.account.child(self.selectAccountFromIncome).update({
                  amount: Number(snap.val().amount) + Number(self.incomeAmount)
                  })
                  self.snackbarSuccess=true;
                  self.snackbarSuccessText = "Income Received";
                  setTimeout(function(){
                    self.addInvoiceIncome(self.incomeVia,self.selectIncome,incomeAccountFirm, self.incomeAmount,self.incomeRemark,incomeAccountNumber)
                    self.incomeAmount = null;
                    self.selectAccountFromIncome = null;
                    self.incomeRemark = null;
                    self.selectIncome = null;
                  })
                }
              })
            }
          }else{
            this.snackbar = true;
            this.snackbarText = 'Please enter Income Source'
          }
        }else{
          this.snackbar = true;
          this.snackbarText = 'Please enter an Amount Recieved'
        }
      }else{
        this.snackbar = true;
        this.snackbarText = 'Please enter a Remark'
      }
    },
    addIncome:function(e){
      let incomeData = {
          brand: this.selectedBrand,
          income: e.target.value
      }
      this.$root.$firebaseRefs.incomes.push(incomeData);
    },
    
    // Income Functionality
    assetAmountClick:function(e){
      var self=this;
      if(this.assetRemark !=null){
        if(this.assetAmount != null){
          if(this.selectAsset != null){
            if(this.assetVia == 'cash'){
              this.$root.$firebaseRefs.firm.child(this.selectedFirmFromAsset).once('value').then( function(snap) {
                // if(Number(snap.val().amount) >= self.incomeAmount) 
                  {
                  self.$root.$firebaseRefs.firm.child(self.selectedFirmFromAsset).update({
                  amount: Number(snap.val().amount) + Number(self.assetAmount)
                  })
                  self.snackbarSuccess=true;
                  self.snackbarSuccessText = "assets Received";
                  setTimeout(function(){
                    self.addInvoiceAsset(self.assetVia,self.selectAsset,self.selectedFirmFromAsset, self.assetAmount,self.assetRemark)
                    self.assetAmount = null;
                    self.selectedFirmFromAsset = null;
                    self.assetRemark = null;
                    self.selectAsset = null;
                  })
                }
              })
            }else{
              let assetAccountFirm= null;
              let assetAccountNumber =null;
              this.$root.$firebaseRefs.account.child(this.selectAccountFromAsset).once('value').then( function(snap) {
                assetAccountFirm = snap.val().firm;
                assetAccountNumber = snap.val().accountnumber;
                // if(Number(snap.val().amount) >= self.incomeAmount)
                {
                  self.$root.$firebaseRefs.account.child(self.selectAccountFromAsset).update({
                  amount: Number(snap.val().amount) + Number(self.assetAmount)
                  })
                  self.snackbarSuccess=true;
                  self.snackbarSuccessText = "Assets Maintained";
                  setTimeout(function(){
                    self.addInvoiceAsset(self.assetVia,self.selectAsset,assetAccountFirm, self.assetAmount,self.assetRemark,assetAccountNumber)
                    self.assetAmount = null;
                    self.selectAccountFromAsset = null;
                    self.assetRemark = null;
                    self.selectAsset = null;
                  })
                }
              })
            }
          }else{
            this.snackbar = true;
            this.snackbarText = 'Please enter Asset Source'
          }
        }else{
          this.snackbar = true;
          this.snackbarText = 'Please enter an Asset Amount'
        }
      }else{
        this.snackbar = true;
        this.snackbarText = 'Please enter a Remark'
      }
    },
    addAsset:function(e){
      let assetData = {
          brand: this.selectedBrand,
          asset: e.target.value
      }
      this.$root.$firebaseRefs.assets.push(assetData);
    },    
  },
  watch: {
    transferType(newVal, oldVal) {
        console.log(newVal)
      if (oldVal !== newVal) {
        switch (newVal) {
        
          case 'Transfer' : {
            this.transfer = true;
            this.deposit = false;
            this.withdrawl = false;
            break;
          }
          case 'Deposit' : {
            this.transfer = false;
            this.deposit = true;
            this.withdrawl = false;
            break;
          }
          case 'Withdrawl' : {
            this.transfer = false;
            this.deposit = false;
            this.withdrawl = true;
            break;
          }
        }
      }
    },
  } 
}
</script>



// WEBPACK FOOTER //
// src/components/InvoiceManagement/index.vue